import {
  FETCH_CONTRACTS_BEGIN,
  FETCH_CONTRACTS_SUCCESS,
  FETCH_CONTRACTS_FAILURE,
  FETCH_CONTRACT_DETAILS_BEGIN,
  FETCH_CONTRACT_DETAILS_SUCCESS,
  FETCH_CONTRACT_DETAILS_FAILURE,
  CREATE_CONTRACT_QUESTION_REQUEST_BEGIN,
  CREATE_CONTRACT_QUESTION_REQUEST_SUCCESS,
  CREATE_CONTRACT_QUESTION_REQUEST_FAILURE,
} from "../actions/contractsAction";

const initialState = {
  contracts: [],
  totalNoOfContract: 0,
  loading: false,
  errors: null,
  request: null,
  questions: {},
};

export interface ContractQuestionRequestStateLoaded {
  is: "LOADED";
  text: string;
}

export interface ContractQuestionRequestStateError {
  is: "ERROR";
  text: string;
}

export interface ContractQuestionRequestStateLoading {
  is: "LOADING";
}

export type ContractQuestionRequestState =
  | ContractQuestionRequestStateLoaded
  | ContractQuestionRequestStateError
  | ContractQuestionRequestStateLoading;

export default function contractsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTRACTS_BEGIN:
      return {
        ...state,
        loading: true,
        contracts: state.contracts || [],
        errors: null,
        request: action.payload,
      };

    case FETCH_CONTRACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        contracts: action.payload.contractsResponse.contracts || [],
        totalNoOfContract:
          action.payload.contractsResponse.totalNoOfContract || 0,
        merge: false,
      };
    case FETCH_CONTRACTS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        contracts: [],
        merge: false,
      };
    case FETCH_CONTRACT_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
        errors: action.payload.errors,
      };
    case FETCH_CONTRACT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        contracts: action.payload.contractsResponse || [],
      };
    case FETCH_CONTRACT_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };

    case CREATE_CONTRACT_QUESTION_REQUEST_BEGIN:
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.payload.guid]: {
            is: "LOADING",
          },
        },
      };

    case CREATE_CONTRACT_QUESTION_REQUEST_SUCCESS:
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.payload.guid]: {
            is: "LOADED",
            text: action.payload.response.text,
          },
        },
      };

    case CREATE_CONTRACT_QUESTION_REQUEST_FAILURE:
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.payload.guid]: {
            is: "ERROR",
            text: action.payload.error,
          },
        },
      };
    default:
      return state;
  }
}
